"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const framer_motion_1 = require("framer-motion");
const PartyWorksTable_1 = __importDefault(require("@Components/SearchByParty/PartyWorksTable"));
const mobx_react_1 = require("mobx-react");
const AnimatedPartyTables = ({ searchPartyStore, partyResultsTable }) => (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement(framer_motion_1.AnimatePresence, null, searchPartyStore.showWorks && (react_1.default.createElement(framer_motion_1.motion.div, { initial: { x: 10, opacity: 0 }, animate: { x: 0, opacity: 1 }, exit: { x: -10, opacity: 0 }, transition: { duration: 0.2, type: 'spring' } },
        react_1.default.createElement(PartyWorksTable_1.default, { searchPartyStore: searchPartyStore })))),
    !searchPartyStore.showWorks && partyResultsTable));
exports.default = (0, mobx_react_1.observer)(AnimatedPartyTables);
